module.exports = __webpack_public_path__ + "static/media/Safari-dark.15426dc8.png";